import React , {useEffect, useState}from 'react';
import { Image , Icon, GridRow , Popup, Label} from 'semantic-ui-react';
import {map } from "lodash"
import {Link, Switch} from "react-router-dom"
import { useQuery } from '@apollo/client';
import { GET_SAM } from '../../../gql/publication';
import ModalBasic from '../../../components/ModalBasic';
import Price from '../../../components/Publications/public/pricefed';
import TitleEx from "../FedExterior/TitleEx/TitleEx"
//import Footer from "../Footer/Footer"
import { useMutation } from '@apollo/client';
import {COUNTGLOBAL} from "../../../gql/global";
import { GETGLOBAL } from '../../../gql/global';
import { HeadProvider, Title, Meta, Base, Link as Link1} from 'react-head';
import WhatSend from '../WhatSend';




import "./FedExterior.scss";
import { date } from 'yup';

export default function FedExterior(props) {

  const {getGlobal} = props;
  const [showModal, setShowModal] = useState (false);
  const [publicationSelect, setPublicationSelect ] = useState (null);
  const {data, loading,startPolling,stopPolling }= useQuery (GET_SAM);
  const [titleModal, setTitleModal] = useState ("")
  const [childrenModal, setChildrenModal] = useState (null) 
  const [updateGlobal] = useMutation (COUNTGLOBAL);
  console.log(getGlobal)
  useEffect(() => {
    // console.log ("hola ")
   
        
      //console.log ("hi")
   
      
        try {
          updateGlobal({
            variables:{	input:{
              id:"67355bb3437eedf7b8e59490",
              countGlobal: getGlobal[0].countGlobal + 1 ,
              createAt:new Date() ,
              //createAt2:new Date(),

            }},
   
               
          });
          
          
        } catch (error) {
          console.log (error);
          
        }
    
   }, [])


   

useEffect(() => {
  



  startPolling(12000)
  return () => {
   stopPolling();
  }
}, [startPolling,stopPolling])





  if (loading) return null;
  const {getSample} = data;
  
  



  return (

    <>

<HeadProvider>


<Link rel="apple-touch-icon" href="%PUBLIC_URL%/logo192.png" />
    
<Link rel="manifest" href="%PUBLIC_URL%/manifest.json" />
     
     
<Title>lacolme</Title>  

<link rel="apple-touch-icon" href="%PUBLIC_URL%/logo192.png" />
    
<link rel="manifest" href="%PUBLIC_URL%/manifest.json" />
    

<Meta name="description" content="E.shop local colaborativa de establecimeientos y personas basada en el contacto directo por WhatsApp"/>


<Meta property="og:url" content="https://lacolme.shop"/>
<Meta property="og:type" content="website"/>
<Meta property="og:title" content="La colme"/>
<Meta property="og:description" content="E.shop local colaborativa de establecimeientos y personas basada en el contacto directo por WhatsApp"/>
<Meta property="og:image" content="https://opengraph.b-cdn.net/production/images/31c09b53-273f-4e27-907a-687154bc4a1b.jpg?token=52rOg1PPgt_n3_vrAPkWMDwi0towb9iJnIdfU7vGLk4&height=400&width=400&expires=33289845781"/>


<Meta name="twitter:card" content="summary_large_image"/>
<Meta property="twitter:domain" content="lacolme.shop"/>
<Meta property="twitter:url" content="https://lacolme.shop"/>
<Meta name="twitter:title" content="La colme"/>
<Meta name="twitter:description" content="E.shop local colaborativa de establecimeientos y personas basada en el contacto directo por WhatsApp"/>
<Meta name="twitter:image" content="https://opengraph.b-cdn.net/production/images/31c09b53-273f-4e27-907a-687154bc4a1b.jpg?token=52rOg1PPgt_n3_vrAPkWMDwi0towb9iJnIdfU7vGLk4&height=400&width=400&expires=33289845781"/>



    

    
  </HeadProvider>

<div className='fedex' >



        {map (getSample,(publication, index) => (
          <div key = {index} className = "fedex_box">
            
              <div className='fedex_box_user'>
              
              <TitleEx publication={publication}  publi={publication.title} />
               </div>

               <div className='feed_box_precio' mobile={16}>
   
               
            </div>
            <Link to = {`/Publication/${publication._id}`}>
            <div  className='fedex_box_photo' style={{backgroundImage:`url("${publication.file}")`}}
            
            />
            </Link>

            
  

            <div className='fedex_box_ubic'>

              
               <span><Icon name = "map marker alternate"/>{publication.area}</span>

    
               
              
            </div>

           
            
           

             
            </div>

        ))}
       
    </div>



    




    
    
</>
  
  
 ) 
  
  };
